import { FC } from 'react';

import { IconProps } from '.';

export const LogoutIcon: FC<IconProps> = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.501 1.667c-1.4 0-2.217-.043-3.014.363-.627.32-1.137.83-1.457 1.456-.406.797-.363 1.615-.363 3.015v6.998c0 1.4-.043 2.218.363 3.015.32.627.83 1.137 1.457 1.456.797.406 1.614.363 3.014.363h1a.833.833 0 1 0 0-1.666h-1c-1.4 0-1.985-.044-2.257-.183a1.66 1.66 0 0 1-.728-.727c-.139-.273-.182-.858-.182-2.258V6.501c0-1.4.043-1.985.182-2.258.16-.313.414-.567.728-.727.272-.14.857-.183 2.257-.183h1a.833.833 0 0 0 0-1.666zm6.244 3.577a.833.833 0 0 0 0 1.179l2.744 2.744H7.5a.833.833 0 1 0 0 1.667h7.988l-2.744 2.744a.833.833 0 1 0 1.178 1.178l4.167-4.167a.83.83 0 0 0 .216-.522l.028-.067a1 1 0 0 0-.028-.138v-.078l-.023-.04a.8.8 0 0 0-.193-.333l-4.167-4.167a.833.833 0 0 0-1.178 0"
      fill="#737373"
    />
  </svg>
);
